export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n    <path d=\"M18 9H6l6 6 6-6z\"/>\n</svg>\n"